<template>
  <div class="page-container">
    <div class="toHome" @click="toHome"></div>
    <img src="../asset/img/2.jpg" alt="产品" class="full-image">
  </div>
</template>

<script>
export default {
  name: 'product',
  methods: {
    toHome() {
      this.$router.push('/');
    }
  }
};
</script>

<style scoped lang="less">
.page-container {
  width: 100%;
  min-height: 100vh;
}

.toHome {
  position: absolute;
top:10px;
left:455px;
width:60px;
height:30px;
}

.full-image {
  width: 100%;
  height: auto;
  display: block;
}
</style>